export enum ELocale {
  ENGLISH = 'en-US',
  VIETNAM = 'vi-VN',
  JAPAN = 'ja-JP',
  THAILAN = 'th-TH',
  INDONESIA = 'id-ID',
  MALAYSIA = 'ms-MY',
  CHINA = 'zh-CN',
}

export interface IFirebaseConfig {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
  measurementId: string
}

export enum EDeviceType {
  DESKTOP = 'Desktop',
  MOBILE = 'Mobile',
}

export enum ECookieVariable {
    // ======================= User related =======================
    USER_ACCESS_TOKEN = 'promax_admin_usr_ac_tk',
    USER_REFRESH_TOKEN = 'promax_admin_usr_rf_tk',
    USER_LOCALE = 'promax_admin_locale',
    USER_SYMBOL_ACTIVE_NAME = 'promax_admin_symbol_active_name',
    USER_SYMBOL_ACTIVE_ID = 'promax_admin_symbol_active_id',
    USER_TRADE_COIN = 'promax_admin_trade_coin',
}
